// Нет долгов
export const NO_DEBTS = 'NoDebts'

// Долги по налогам
export const TAX_DEBTS = 'TaxDebts'

// Долг по соц. платежам
export const SOCIAL_DEBTS = 'SocialDebts'

// Долг по налогам и соц. платежам
export const TAX_AND_SOCIAL_DEBTS = 'TaxAndSocialDebts'

// Долг по налогам и/или соц. платежам
export const UNDEFINED_DEBTS = 'UndefinedDebts'
